(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 61225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34168);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63289);



/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const [match, setMatch] = react__WEBPACK_IMPORTED_MODULE_0__.useState(() => {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  });
  (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    let active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    const queryList = matchMedia(query);

    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch(); // TODO: Use `addEventListener` once support for Safari < 14 is dropped

    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);
  return match;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814


const maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useSyncExternalStore' + ''];

function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
  const getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }

    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia]);
  const [getSnapshot, subscribe] = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }

    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}

function useMediaQuery(queryInput, options = {}) {
  const theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(); // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr
  } = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });

  if (false) {}

  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable

  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);

  if (false) {}

  return match;
}

/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(18888);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(92557);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

;// CONCATENATED MODULE: ./blocks/Header/Header.tsx














var Header = function() {
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref.openDialogue, closeDialogue = ref.closeDialogue, dialogueState = ref.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Discover MyLER",
                            path: constants/* navigationPaths.DISCOVER_MYLER */.aY.DISCOVER_MYLER,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 2 modules
var Footer = __webpack_require__(93335);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "MyLE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 18888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./blocks/not-found/NotFound.module.scss
var NotFound_module = __webpack_require__(96953);
var NotFound_module_default = /*#__PURE__*/__webpack_require__.n(NotFound_module);
// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./assets/not-found/not-found-img.jpg
/* harmony default export */ var not_found_img = ({"src":"/_next/static/media/not-found-img.6e6ad730.jpg","height":2164,"width":3840,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAEAAQQDAAAAAAAAAAAAAAABAAIDBBEFQUL/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACEf/aAAwDAQACEQMRAD8Ao5nKZJgXFosI1XR1Qj633EREnY5b/9k=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./blocks/not-found/link-list/LinkList.module.scss
var LinkList_module = __webpack_require__(2575);
var LinkList_module_default = /*#__PURE__*/__webpack_require__.n(LinkList_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./blocks/not-found/link-list/LinkList.tsx






/**
 * Predefined list of navigation links for the 404 page.
 * These links provide alternative navigation options when a user lands on a 404 page.
 */ var links = [
    {
        href: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
        text: "Hotels"
    },
    {
        href: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
        text: "Membership"
    },
    {
        href: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
        text: "Gift cards"
    },
    {
        href: constants/* navigationPaths.FAQ */.aY.FAQ,
        text: "FAQ's"
    }, 
];
var LinkList = function() {
    var router = (0,next_router.useRouter)();
    /**
   * Handles click events on navigation links
   *
   * This function prevents the default link behavior and uses router.replace
   * instead of the default Link navigation to handle the browser back button:
   * When a user clicks one of these links and then uses the browser's back button,
   * router.replace ensures they return to their previous valid page instead of
   * triggering data fetching for the non-existent 404 route.
   *
   * @param href - The destination URL
   * @param e - The click event object
   */ var handleClick = function(href) {
        return function(e) {
            e.preventDefault();
            router.replace(href);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (LinkList_module_default()).links,
        children: links.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: item.href,
                passHref: true,
                className: (LinkList_module_default()).linkWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (LinkList_module_default()).link,
                    onClick: handleClick(item.href),
                    role: "link",
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h5",
                        weight: "regular",
                        children: item.text
                    })
                })
            }, item.href);
        })
    });
};
/* harmony default export */ var link_list_LinkList = (LinkList);

;// CONCATENATED MODULE: ./blocks/not-found/link-list/index.ts


// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
;// CONCATENATED MODULE: ./blocks/not-found/NotFound.tsx









var NotFound = function() {
    var isTabletOrMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* breakpoints.md */.AV.md, ")"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        className: (NotFound_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NotFound_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (NotFound_module_default()).hero,
                    priority: true,
                    src: not_found_img,
                    alt: "Not Found 404",
                    quality: 100,
                    layout: isTabletOrMobile ? "fill" : "responsive",
                    objectPosition: "center",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NotFound_module_default()).textOverlay,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h4",
                        weight: "demiBold",
                        className: (NotFound_module_default()).title,
                        children: "That’s embarrassing..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h5",
                        weight: "demiBold",
                        className: (NotFound_module_default()).subtitle,
                        children: "We can't seem to find the page you're looking for, here are some helpful links instead:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_list_LinkList, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var not_found_NotFound = (NotFound);

;// CONCATENATED MODULE: ./blocks/not-found/index.ts


;// CONCATENATED MODULE: ./pages/404.tsx





var Custom404 = function(param) {
    var globalLayoutProps = param.globalLayoutProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found_NotFound, {})
    }));
};
var __N_SSG = true;
/* harmony default export */ var _404 = (Custom404);


/***/ }),

/***/ 96953:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__52t80","imageWrapper":"NotFound_imageWrapper__w9nAX","textOverlay":"NotFound_textOverlay__YOkiB","title":"NotFound_title___B_db","subtitle":"NotFound_subtitle__5EhSZ"};

/***/ }),

/***/ 2575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"links":"LinkList_links__9D9qE","linkWrapper":"LinkList_linkWrapper__7Mn6q","link":"LinkList_link__RXjBg"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48,5675,210,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);